import React from 'react';
import { useAttributeFormBuilder, useComponentProperties } from '../../../../Hooks/Display/useComponentProperties';
import { useTranslation } from 'react-i18next';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';

const CreateSection = () => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [properties, setProperty] = useComponentProperties();
    const selectedComponent = useSelectedComponent();

    const [{ steps }, dispatch] = useAttributeFormBuilder();

    const handleAddSection = () => {
        dispatch.addSection();
    }

    return (
        <button
            disabled={selectedComponent.componentType === 'Cards'}
            className='btn btn-sm btn-secondary mt-2 ms-2 font-weight-bold'
            onClick={handleAddSection}
        >
            <i className='fa fa-plus me-1'></i>
            {
                properties.isMultiStepForm ?
                    t("section.add_section_for_step", { ns: "display/components/form" }) :
                    t("section.add_section", { ns: "display/components/form" })
            }
        </button>
    );
}

export default CreateSection;